import { styled } from 'linaria/react';

export const ButtonContainer = styled('div')`
	display: flex;
	justify-content: center;
	margin-top: auto;
	margin-bottom: 24px;
`;
